import { render } from "./ContentSection.vue?vue&type=template&id=5be2f88a&scoped=true"
import script from "./ContentSection.vue?vue&type=script&lang=js"
export * from "./ContentSection.vue?vue&type=script&lang=js"

import "./ContentSection.vue?vue&type=style&index=0&id=5be2f88a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be2f88a"]])

export default __exports__